import { Hero } from '@/components/sections/Hero'
import { Reality } from '@/components/sections/Reality'
import { TimeEnemy } from '@/components/sections/TimeEnemy'
import { Proposal } from '@/components/sections/Proposal'
import { NoRisk } from '@/components/sections/NoRisk'
import { HowItWorks } from '@/components/sections/HowItWorks'
import { ForEducators } from '@/components/sections/ForEducators'
import { WhyItWorks } from '@/components/sections/WhyItWorks'
import { FinalCTA } from '@/components/sections/FinalCTA'

export default function Index() {
  return (
    <div className="w-full overflow-x-hidden">
      <Hero />
      <Reality />
      <TimeEnemy />
      <Proposal />
      <NoRisk />
      <HowItWorks />
      <ForEducators />
      <WhyItWorks />
      <FinalCTA />
    </div>
  )
}
